<template>
  <div id="app">
    <el-header height="50px">
      <crm-header v-if="$route.path !== '/'"></crm-header>
    </el-header>
    <crm-container v-if="$route.path !== '/'">
      <router-view></router-view>
    </crm-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import store from './store';
import router from './routes';
import qs from 'qs';
import crmContainer from '@/components/layouts/crmContainer';
import CrmHeader from '@/components/layouts/crmHeader';
import watermaker from '@/scripts/watermaker.js';

export default {
  /**
     * The Vuex store
     */
  store,

  /**
     * The router
     */
  router,

  /**
     * Fires when the app has been mounted
     */
  components: {
    crmContainer,
    CrmHeader,
  },
  computed: {
    ...mapGetters({
      freePages: 'authority/freePages',
      userInfo: 'authority/userInfo',
    }),
  },
  methods: {
    ...mapActions({
      getUserInfo: 'authority/getUserInfo',
    }),
  },
  async created() {
    if (window.location.pathname === '/') {
      await store.dispatch('authority/getUserInfo')
      await this.$router.push('/home')
      return
    }
    const gtcrm = 'Gtcrm';
    let token = '';
    if (location.search) {
      token = qs.parse(location.search.substr(1))[gtcrm] || '';
    }
    sessionStorage.setItem('token', token);
  },
  mounted() {
  },
  updated() {
    watermaker.set(`${this.userInfo.userName}-${this.userInfo.loginId}`);
  },
};
</script>

<style lang="less">
#app {
  width: calc(100vw);
  height:calc(100vh);
  overflow: hidden;
}
.el-header {
  padding: 0!important;
}
</style>
